import { useQueryClient } from '@tanstack/react-query';

import { getProperty, getPropertyMappings } from '~/services/AccommodationService';

export const propertyMappingQueryKeys = {
  all: ['accommodation', 'property-mappings'] as const,
  detail: (reservationPropertyId?: string) => [...propertyMappingQueryKeys.all, reservationPropertyId] as const,
};

export const adminPropertyQueryKeys = {
  all: ['accommodation', 'admin-properties'] as const,
  detail: (propertyId?: string) => [...adminPropertyQueryKeys.all, propertyId] as const,
};

export function useGetPropertyLogoIdByReservationId() {
  const queryClient = useQueryClient();

  const fetchLogoId = async (reservationPropertyId: string) => {
    const mapping = await queryClient.fetchQuery({
      queryKey: propertyMappingQueryKeys.detail(reservationPropertyId),
      queryFn: async () => {
        const response = await getPropertyMappings({ reservationPropertyId });
        return response.result;
      },
    });

    if (!mapping?.id) {
      return null;
    }

    const property = await queryClient.fetchQuery({
      queryKey: adminPropertyQueryKeys.detail(mapping.id),
      queryFn: async () => {
        const response = await getProperty({ propertyId: mapping.id });
        return response.result;
      },
    });

    return property.logoId ?? null;
  };

  return { fetchLogoId };
}
